// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonLinkComponent_button__khbFY"};